module.exports = __webpack_public_path__ + "static/media/playbase.29599652.png";